import { render, staticRenderFns } from "./index.vue?vue&type=template&id=15589a59"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=15589a59&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AdvBanner: require('/app/app/components/adv/Banner/index.vue').default,WidgetSpacingHeader: require('/app/app/components/widget/SpacingHeader/index.vue').default})
